{
  "UnifiedNavigation": "Naviga in Experience Cloud",
  "adobeExperienceCloudNoOrgsSelect": "Seleziona un altro account organizzazione",
  "help": "Aiuto",
  "ok": "OK",
  "profile": "Profilo",
  "searchButton": "Cerca",
  "sidenavMenuCloseTooltip": "Chiudi menu",
  "sidenavMenuLockTooltip": "Clic per bloccare il menu",
  "solutionSwitcher": "Passa a un’altra soluzione",
  "themeCoachMark": "Tema chiaro",
  "themeCoachMarkMessage": "Ora l’intestazione Experience Cloud supporta i temi chiaro e scuro. Per impostare il tema che preferisci, fai clic sul tuo avatar.",
  "toggleSideNav": "Attiva/Disattiva il menu di navigazione laterale"
}
